import dialogButtonStyle from "assets/jss/default/components/dialogButtonStyle.js";

const newCaseWithDiagnosticDialogStyle = {
  statusWrapper: {
    backgroundColor: "#f4f4f4",
    position: "relative",
    padding: "11px 15px"
  },
  title: {
    padding: "20px 0 10px 20px",
    "& > h2": {
      fontWeight: "600",
      fontSize: "1.6rem"
    }
  },
  requiredField: {
    color: "red",
    marginLeft: "3px"
  },
  accordionSection: {
    "& .MuiAccordion-root.MuiPaper-elevation1": {
      boxShadow: "none"
    },
    "& .MuiAccordion-root.Mui-expanded": {
      margin: "0"
    },
    "& MuiAccordionSummary-content Mui-expanded": {
      margin: "0"
    }
  },
  dividerWrapper: {
    padding: "0px 15px"
  },
  firstDividerMargin: {
    marginTop: "30px"
  },
  lastDividerMargin: {
    marginBottom: "30px"
  },
  accordionHeader: {
    padding: "0"
  },
  imageDropWrapper: {
    height: "245px",
    "& .MuiDropzoneArea-text": {
      fontSize: "18px"
    },
    "& .MuiDropzoneArea-root": {
      minHeight: "0px",
      height: "inherit"
    }
  },
  fileCard: {
    height: "255px",
    borderRadius: "10px"
  },
  fileImage: {
    height: "80%"
  },
  keyObservationField: {
    marginBottom: "18px"
  },
  summaryFieldsSection: {
    padding: "0 40px 10px 10px"
  },
  componentField: {
    "& .MuiSelect-filled.MuiSelect-filled": {
      paddingBottom: "26px"
    }
  },
  ...dialogButtonStyle
};

export default newCaseWithDiagnosticDialogStyle;
